module.exports = __webpack_public_path__ + "static/media/Hero_1_MF.4faf9acf.png";